import { Wrapper } from './styles'

const Component = ({children, forwardRef, ...rest}:any) =>{
  return <Wrapper {...rest} ref={forwardRef}>{children}</Wrapper>
}

export default Component
